import { AdvancedMarker, APIProvider, Map, useMap } from "@vis.gl/react-google-maps";
import React, { useEffect } from "react";
import Style from "./mapshowlocationscomponent.module.scss";

/**
 *
 * 
 */
export type IMapShowLocationsComponent = {
  uid: string,
  numberOnMap: number | undefined,
  lat: number,
  lng: number
  color: string,
}

interface MapComponentProps {
  onLocationSelected?: (uid: string) => void;
  centerOnMap: (index: string) => void;
  locations: IMapShowLocationsComponent[]
}

const InnerMap: React.FC<MapComponentProps> = ({ locations }) => {

  const map = useMap();

  // Wenn centerOnMap aufgerufen wird, zentriere auf den Marker
  useEffect(() => {
    const handleCenterOnMap = (index: string) => {
      const location = locations.find(loc => loc.uid === index);
      if (location && map) {
        map.setCenter({ lat: location.lat, lng: location.lng });
        //map.setZoom(15); // optional: Zoom einstellen

        // Highlight des zugehörigen AdvancedMarker-Divs
        const el = document.getElementById(`marker-${index}`);
        if (el) {
          el.classList.add(Style.highlight);
          // wieder entfernen nach 2.5s
          window.setTimeout(() => el.classList.remove(Style.highlight), 2500);
        }
      }
    };

    // Registriere die Callback-Funktion
    (window as any).centerMapCallback = handleCenterOnMap;
  }, [locations, map]);

  useEffect(() => {
  }, []);

  return (
    <>
      <Map
        className={Style.map}
        style={{ minHeight: "100px", minWidth: "100px", height: "500px" }}
        mapId={'a'}
        defaultZoom={10}
        defaultCenter={{ lat: 53.17733483052828, lng: 7.762240042553961 }}
        gestureHandling={'greedy'}
        disableDefaultUI={false}
      >
        {locations.map((e1) =>
          <React.Fragment key={e1.uid}>
            {(e1.lat > 0 && e1.lng > 0) &&
              <AdvancedMarker
                position={{ lat: e1.lat, lng: e1.lng }}
                onClick={(e) => {
                  e.stop();
                  document.getElementById('number' + e1.numberOnMap + 'Auftrag')?.scrollIntoView()
                }}
                draggable={false}
              >
                <div
                  id={`marker-${e1.uid}`} // <- ID zum Hervorheben
                  className={Style.markerInner} // Basis-Stil
                  style={{
                    backgroundColor: e1.color,
                  }}
                >
                  {e1.numberOnMap}
                </div>
              </AdvancedMarker>}
          </React.Fragment>
        )}
      </Map>
    </>
  );
}

const MapComponent: React.FC<MapComponentProps> = ({ locations, centerOnMap }) => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_KEY!!;

  return (
    <APIProvider apiKey={googleMapsApiKey} solutionChannel='GMP_devsite_samples_v3_rgmautocomplete'>
      <InnerMap locations={locations} centerOnMap={centerOnMap} />
    </APIProvider>
  );
};

export default MapComponent;